export default __webpack_public_path__ + "static/media/Darya_Allen-Attar_AHV_In_Moms_We_Trust.5f3861ae.jpg";